export default __webpack_public_path__ + "static/media/blogIcon.c40f7312.jpg";